import { Accordion, AccordionItem, Col, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import { getMinaraInfo, getUnicaPayInfo } from '../../../slice';

import { MinaraHub } from '../MinaraHub';

export const Minara = () => {
  const { loading, minara } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getMinaraInfo(Number(userId)));
  }, [dispatch]);

  return (
    <div>
      <div className='accordion-body'>
        {minara?.map((data, i) => (
          <MinaraHub key={i} data={data} />
        ))}
      </div>
    </div>
  );
};
